export const vendorLabel = "Vendor";
export const vendorName = "Vendor Name";
export const addvendorLabel = "Add Vendor";
export const editvendorLabel = "Edit Vendor";
export const vendorIdLabel = "Vendor Id";
export const organization = "Organization";
export const panLabel = "PAN";
export const editVendorLabel = "Edit Vendor";
export const newVendorLabel = "New Vendor";
export const organizationKey = "bankDetail.organization";
export const organizationLabel = "Organization";
export const gstinLabel = "GSTIN No.";
export const organizationPlaceHolder = "organization";

export const vendorMsmeOptions = [
  { id: "msmeYes", value: "true", label: "Yes" },
  { id: "msmeNo", value: "false", label: "No" },
];
